export const FILTER_BY_CATEGORY = "FILTER_BY_CATEGORY";

export const filterByCategory = (category) => {
  return { type: FILTER_BY_CATEGORY, payload: category };
};
